import React from "react";
import { BoxHeaderInner } from "@/components/styled";
import Layout from "@/components/Layout";
import BudgetWidget from "@/components/BudgetWidget";
import LatestUpdates from "@/components/LatestUpdates";
import AnalysisChart from "@/components/AnalysisChart";
import TotalBalance from "@/components/TotalBalance";
import NewProjectApplicationsToggle from "@/pages/HomePage/components/NewProjectApplicationsToggle.tsx";
import { useAuthStore } from "@/store/authStore.ts";
import { Grid } from "@mui/material";

const BudgetPage = () => {
  const role = useAuthStore((state) => state.role);
  const isAdmin = role === "administrator";

  return (
    <Layout>
      <Grid
        sx={{
          marginTop: "4px",
          position: "relative",
          zIndex: 10,
          display: "flex",
        }}
        container
        columns={12}
        columnSpacing={"24px"}
        rowSpacing={"24px"}
      >
        <Grid sx={{ width: "100%" }} item xs={12} md={isAdmin ? 9 : 12}>
          <Grid
            container
            rowSpacing={"24px"}
            columnSpacing={"24px"}
            columns={12}
          >
            <Grid item xs={12} lg={12} xl={isAdmin ? 8 : 12}>
              <BudgetWidget />
            </Grid>
            {isAdmin && (
              <Grid item xs={12} lg={12} xl={4}>
                <NewProjectApplicationsToggle />
                <LatestUpdates />
              </Grid>
            )}
            {isAdmin && (
              <Grid item xs={12} md={12} mb={2}>
                <AnalysisChart />
              </Grid>
            )}
          </Grid>
        </Grid>
        {isAdmin && (
          <Grid
            sx={{
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              width: "100%",
            }}
            item
            xs={12}
            md={3}
          >
            <TotalBalance />
          </Grid>
        )}
      </Grid>
      <BoxHeaderInner />
    </Layout>
  );
};

export default BudgetPage;
